/* src/app/warehousing/pages/storage-rates/storage-rates.component.scss */
/*# sourceMappingURL=storage-rates.component.css.map */
